import { Skeleton } from "shared/ui/shadcn/skeleton";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import { clsxMerge } from "shared/lib/helpers";

const EventAttendeeSkeleton = ({ className }: PropsWithClassNameI) => (
  <div className={clsxMerge("flex w-full gap-2 p-2", className)}>
    <Skeleton className="h-9 w-9 rounded-full" />

    <div className="flex grow flex-col gap-2">
      <Skeleton className="h-3 w-full rounded" />
      <div className="flex gap-1">
        <Skeleton className="h-3 w-12 rounded" />
        <Skeleton className="h-3 w-20 rounded" />
      </div>
    </div>
  </div>
);

const PENDING_ATTENDEES_AMOUNT = 2;

export const BookedMeetingCalendarEventStates = {
  Pending: () => (
    <div className="z-[100] flex w-[250px] flex-col items-center gap-3 text-black">
      {Array.from({ length: PENDING_ATTENDEES_AMOUNT }).map((_, idx) => (
        <EventAttendeeSkeleton key={idx} className="w-full" />
      ))}
    </div>
  ),
};
